export default __webpack_public_path__ + "static/media/jewelry-soft-summer.7c9c77d1.png";